import { LooseOrderSubtype } from './loose-order';

export interface DeliveredLooseOrderView {
	id: number;
	subtype: LooseOrderSubtype;
	address: string;
	contact: string | null;
	client: {
		id: number;
		name: string;
		phone: string;
	};
	wasteType: string;
	count: number;
	deliveryDate: string;
	claimingDate: string | null;
}
